import React from 'react';
import WhyMSTechComponent from '../components/WhyMSTech/WhyMSTech';

/**
 * WhyMSTechnologiesPage - Why MS Technologies page wrapper
 */
export default function WhyMSTechnologiesPage() {
  return <WhyMSTechComponent />;
}
